import { FileSelector } from './components/FileSelector';
import { UploadConfig } from './components/UploadConfig';
import { UploadResultList } from './components/UploadResultList';
import { useFileUpload } from './hooks/useFileUpload';

export default function FileUpload() {
	const {
		env,
		project,
		fileList,
		uploadedFiles,
		uploading,
		uploadProgress,
		setEnv,
		setProject,
		getBasePath,
		handleUpload,
		handleCopyUrl,
		handleRemoveUploaded,
		uploadProps,
	} = useFileUpload();

	return (
		<div>
			<UploadConfig
				env={env}
				project={project}
				basePath={getBasePath()}
				onEnvChange={setEnv}
				onProjectChange={setProject}
			/>

			<FileSelector
				fileList={fileList}
				uploading={uploading}
				uploadProgress={uploadProgress}
				uploadProps={uploadProps}
				onUpload={handleUpload}
			/>

			<UploadResultList
				uploadedFiles={uploadedFiles}
				onCopyUrl={handleCopyUrl}
				onRemove={handleRemoveUploaded}
			/>
		</div>
	);
}
